import {
  grey,
  danger,
} from '../../../../../utils/brand-colors';
import { commonStyles } from '../../styles';

export default () => ({
  ...commonStyles,
  eventIdField: { color: grey[500] },
  eventName: { display: 'flex' },
  eventNameContainer: { display: 'flex' },
  dueDateIcon: {
    marginLeft: 4,
    fontSize: '18px',
    color: danger.main,
  },
  row: {
    cursor: 'pointer',
    '&:hover': { background: grey[50] },
  },
  statusContainer: {
    display: 'flex',
    alignItems: 'center',
  },
  statusName: { marginLeft: 4 },
});
